import { translations } from '@internal/i18n/translations'
import { KnownBaleChamberType } from '../KnownBalerChamberType'
import { KnownMachineHeaderType } from '../KnownMachineHeaderType'
import { BalerSubType } from '../MachineType'

export const balerSubtypeTranslationMapping: Record<BalerSubType, string> = {
  [BalerSubType.BALER_WRAPPER_COMBINATION]:
    translations.balerWrapperCombination,
  [BalerSubType.HIGH_DENSITY_BALER]: translations.highDensityBaler,
  [BalerSubType.OTHER]: translations.balerOther,
  [BalerSubType.ROUND_BALER]: translations.roundBaler,
  [BalerSubType.SQUARE_BALER]: translations.squareBaler,
}

export const baleChamberTranslationMapping: Record<
  KnownBaleChamberType,
  string
> = {
  [KnownBaleChamberType.FIXED_CHAMBER]: translations.fixedChamber,
  [KnownBaleChamberType.SEMI_VARIABLE_CHAMBER]:
    translations.semiVariableChamber,
  [KnownBaleChamberType.VARIABLE_CHAMBER]: translations.variableChamber,
}

export const machineHeaderTypeTranslationMapping: Record<
  KnownMachineHeaderType,
  string
> = {
  [KnownMachineHeaderType.FRONT_END_EXTENSION]: translations.frontEndExtension,
  [KnownMachineHeaderType.GRAIN_HEADER]: translations.grainHeader,
  [KnownMachineHeaderType.GRASS_SEED_HEADER]: translations.grassSeedHeader,
  [KnownMachineHeaderType.MAIZE_HEADER]: translations.maizeHeader,
  [KnownMachineHeaderType.RAPESEED_HEADER]: translations.rapeseedHeader,
  [KnownMachineHeaderType.SUNFLOWER_HEADER]: translations.sunflowerHeader,
  [KnownMachineHeaderType.PICK_UP]: translations.headerPickUp,
  [KnownMachineHeaderType.PICKER]: translations.headerPicker,
  [KnownMachineHeaderType.OTHER]: translations.headerOther,
  [KnownMachineHeaderType.GPS_CUTTING_UNIT]: translations.gpsCuttingUnit,
  [KnownMachineHeaderType.HEADER]: translations.header,
  [KnownMachineHeaderType.MAIZE_PICKER]: translations.maizePicker,
}
